import { Button, Tooltip } from "@mixitone/components";
import TrashIcon from "@mixitone/icons/trash.svg";
import type { ClubPlayer, ClubPlayerToken } from "@mixitone/models";
import { formatDate } from "@mixitone/util";
import ClubPlayerFormController from "components/Forms/ClubPlayerFormController";
import type { CustomComponentFieldProps } from "components/Forms/FormFieldsDefinition";
import { useRef } from "react";

const TokenRow: React.FC<{
  cpt: ClubPlayerToken;
  onDelete: () => void;
}> = ({ cpt, onDelete }) => {
  const targetRef = useRef(null);
  return (
    <div className="flex items-center justify-between rounded-md bg-gray-50 p-2">
      <span ref={targetRef} className="text-sm">
        {cpt.updated_at ? formatDate(cpt.updated_at) : "Date not available"}
      </span>
      <Tooltip targetRef={targetRef} hover>
        {cpt.token?.token_value ?? "Token value not available"}
      </Tooltip>
      <Button type="button" kind="danger" onClick={onDelete}>
        <TrashIcon className="h-4 w-4" />
      </Button>
    </div>
  );
};

const NewTokenRow: React.FC<{ token: string }> = ({ token }) => {
  const targetRef = useRef(null);
  return (
    <div className="flex items-center justify-between rounded-md bg-gray-50 p-2">
      <span ref={targetRef} className="text-sm">
        New token
      </span>
      <Tooltip targetRef={targetRef} hover>
        {token}
      </Tooltip>
    </div>
  );
};

const NfcTokenField: React.FC<CustomComponentFieldProps<ClubPlayer>> = () => {
  const controller = ClubPlayerFormController.use();
  const { token, tokens } = controller.state;

  return (
    <div className="space-y-1">
      {tokens &&
        tokens.length > 0 &&
        tokens.map((cpt: ClubPlayerToken) => (
          <TokenRow key={cpt.id} cpt={cpt} onDelete={() => controller.actionDeleteToken(cpt.id!)} />
        ))}
      {token && <NewTokenRow token={token} />}
      {(!tokens || tokens.length === 0) && !token && (
        <p className="py-2 text-sm text-gray-500">No token assigned</p>
      )}
    </div>
  );
};

export default NfcTokenField;
